import { getChainDisplayName } from '@passkeys/assets';
import ChainIcon from '@passkeys/ui/chain-icon';
import Text from '@passkeys/ui/text';

import type { Asset } from '@/types';
import PickerModal from '@/ui/components/picker-modal';
import actions from '@/ui/flux/actions';
import useChains from '@/ui/hooks/use-chains';
import useEnabledAssets from '@/ui/hooks/use-enabled-assets';

function renderChain(asset: Asset) {
  return (
    <div className="flex items-center gap-x-2">
      <ChainIcon
        colored
        name={asset.name}
        displayName={asset.displayName}
        size={32}
      />
      <Text>{getChainDisplayName(asset)}</Text>
    </div>
  );
}

export interface SelectChainModalProps {
  onClose: (chain?: Asset) => void;
}

function SelectChainModal({ onClose }: SelectChainModalProps) {
  const chains = useChains();
  const assets = useEnabledAssets();

  const chainAssets = chains.map((chain) => assets[chain]);

  return (
    <PickerModal
      options={chainAssets}
      getOptionKey={(asset) => asset.name}
      renderOption={renderChain}
      onClose={onClose}
    />
  );
}

function showSelectChainModal(): Promise<{ result: Asset }> {
  return actions.modal.show({
    title: 'Select chain',
    fullscreen: true,
    reactContent: (
      <SelectChainModal
        onClose={() => {}} // FIXME: Improve `reactContent` type to avoid having to pass `onClose` here.
      />
    ),
  });
}

export default showSelectChainModal;
